function mainNavHeight(remFactor = 16) {
  const mainNav = document.getElementById('main-nav');
  const mqlLg = window.matchMedia('(min-width: 992px)');

  mainNav.style.top = `-${mainNav.offsetHeight / remFactor}rem`;

  mqlLg.addEventListener('change', () => {
    mainNav.style.top = `-${mainNav.offsetHeight / remFactor}rem`;
  });
}

export { mainNavHeight };
